import type { PlayerTag } from '../types'

/**
 * System tags have an immutable seed key used by tactical-map and Discord
 * projections. Their display name remains editable, but catalog cleanup must
 * never remove or recolour the underlying map contract.
 */
export function isSystemTag(tag: Pick<PlayerTag, 'seedKey'>): boolean {
  return tag.seedKey !== null
}
